import { render, staticRenderFns } from "./footer-bar.vue?vue&type=template&id=375b8749&scoped=true&"
import script from "./footer-bar.vue?vue&type=script&lang=js&"
export * from "./footer-bar.vue?vue&type=script&lang=js&"
import style0 from "./footer-bar.vue?vue&type=style&index=0&id=375b8749&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375b8749",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VFooter,VIcon,VSpacer,VTooltip})
